import { render, staticRenderFns } from "./ModificationHistory.vue?vue&type=template&id=376985a5&"
import script from "./ModificationHistory.vue?vue&type=script&lang=js&"
export * from "./ModificationHistory.vue?vue&type=script&lang=js&"
import style0 from "./ModificationHistory.vue?vue&type=style&index=0&id=376985a5&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports